import React from 'react'
import backgroundImg from '../ui/backdrop_kaleidoskop.png'
import ArAppAd from '../core/ArAppAd'
import './kaleidoskop.css'
import KaleidoskopExperience from '../core/webgl/KaleidoskopExperience'

const Kaleidoskop = () => {
  return (
    <>

      <div id='backdropContainer'>

        <img src={backgroundImg} alt="Ein Bild mit Kaleidoskopmuster" id='Backdrop' />
      </div>


      <div className='page'>

        {/* <h1 className='underConstruction'>Diese Seite befindet sich noch im Aufbau</h1> */}
        <h1 className='underConstruction'>[k]kaleidoskop der digitale Rundgang</h1>

        <KaleidoskopExperience></KaleidoskopExperience>


        {/* <h1>How To:</h1>
        <div>
          <p>
            Lorem ipsum dolor sit amet consectetur. Aliquam rhoncus est commodo dictum volutpat fermentum faucibus ut. Id vivamus diam accumsan nullam facilisis egestas non id ac. Fermentum mattis nunc nunc nibh sit. Mattis diam arcu neque volutpat blandit iaculis neque duis leo. Amet sem sem suspendisse fames purus imperdiet egestas risus purus. Vestibulum amet arcu gravida dictum. Et senectus tellus dolor risus curabitur arcu tempus. Pellentesque mattis et et aliquet sapien enim mauris dignissim urna. Augue sollicitudin a diam risus. Elementum dui eu lorem mollis odio. Lectus nunc tincidunt id feugiat nulla. Id sit aliquam egestas in vivamus. Fusce nisl donec eget posuere.
            Dolor bibendum mattis massa quam quam felis tincidunt feugiat. Tincidunt a et rutrum morbi morbi magna felis volutpat ante. Nulla curabitur malesuada nam venenatis pharetra lectus faucibus. Pellentesque fames est egestas sit amet felis massa cras pretium. Ac neque risus fermentum sed viverra. Ullamcorper dignissim metus a diam vel venenatis adipiscing sit suspendisse. Sed etiam sed lorem posuere. Pellentesque diam enim ornare tellus massa magna consectetur. In est ultricies nisl fermentum. Dignissim pharetra mi non adipiscing turpis lobortis neque aliquam purus. Duis massa eget arcu aenean. A aliquam sed tellus tortor. Id imperdiet imperdiet et eget. Pharetra eget fringilla egestas semper lorem nulla.
            Mattis consequat turpis sit porttitor nisi massa. Phasellus quisque tellus blandit maecenas quisque. Turpis aliquet aliquam dolor amet. Commodo varius et tortor consequat aliquam sit nunc ut blandit. Eget mi vulputate leo ridiculus nibh et nibh eu lobortis. Felis sed sed convallis aliquam fermentum nullam aliquam aliquet neque. Nunc integer aenean in vulputate. Pretium ac donec neque lacus vi
          </p>
        </div>

        <h1>The Experience</h1>
        <p>the experience will be embeded here</p>


        <h1>Mobile-App</h1>
        <p>
          Lorem ipsum dolor sit amet consectetur. Nunc tellus mattis pharetra condimentum massa turpis congue. Dis arcu sem erat netus enim auctor consectetur arcu tortor. Risus eget sed tempus mattis velit quis cras. Eleifend quisque blandit aliquet adipiscing nisl elit. Id feugiat sit a tincidunt senectus sapien proin interdum. Rhoncus nisl porta pellentesque eu odio pharetra accumsan donec risus. Pulvinar viverra mauris feugiat auctor convallis massa quis purus. Tellus aliquam id tincidunt donec eget purus orci maecenas mauris. Commodo a aliquam lobortis tellus imperdiet. Mauris hendrerit tortor amet eleifend tincidunt.
          Euismod nisl scelerisque suscipit non accumsan tellus praesent sagittis ac. Fermentum enim nulla ut sem.
        </p> */}


      </div>

      <ArAppAd></ArAppAd>

    </>
  )
}

export default Kaleidoskop